/* ============================================================
   ATICA Suit Builder -- off-the-rack suit configurator.
   Composable multi-block build. Each block is a Prestige product block the
   merchant can reorder / remove / interleave with other blocks:
     data-suit-part="mode"      purchase-mode tabs (Full Suit / Jacket / Trousers) -- sits at top
     data-suit-part="price"     live total (near the title, like a standard PDP)
     data-suit-part="jacket"    lapel / fit / size / length (+ "How to choose a fit" link)
     data-suit-part="trousers"  trouser fit / waist
     data-suit-part="cart"      Add-to-cart BUTTON ONLY, native Prestige button markup
     data-suit-part="fitguide"  right-slide drawer (body-type image + copy per fit)
     data-suit-part="all"       everything in one block (legacy/simple)
   ONE controller per product (keyed by suit_sku) is the single source of
   truth: every mounted block reads/writes it, so selections stay in sync
   regardless of block ORDER, and a missing block degrades gracefully
   (available purchase modes are derived from which selector blocks exist).
   Adds ONE or TWO line items via the AJAX Cart API (set price = plain sum;
   the two lines just group visually via _suit_set). Hosted on Shopify FILES.
   ES5-safe (Shopify minifies Files JS -- keep it minification-proof).
   ============================================================ */
(function () {
  if (window.__SUIT_BUILDER_LOADED__) return;   // script may be included by several blocks; run once
  window.__SUIT_BUILDER_LOADED__ = true;
  window.__SUIT_CTRL__ = window.__SUIT_CTRL__ || {};

  // ---------- shared helpers ----------
  function num(gid) { return String(gid).split('/').pop(); }
  function money(n) { return '$' + Number(n).toFixed(2); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function attr(node, name, def) { var v = node && node.getAttribute(name); return (v == null || v === '') ? def : v; }
  function fitLabel(v) { return String(v).replace(/Alexander/i, 'Classic').replace(/Lorenzo/i, 'Slim').replace(/\s*\/\s*/, ' \u00b7 '); }
  function modelOf(fitKey) { return String(fitKey).split('/')[0].replace(/\s+$/, ''); }
  function dropOf(fitKey)  { var p = String(fitKey).split('/'); return p[1] ? p[1].replace(/^\s+/, '') : ''; }
  var FIT_MAP = [
    { label: 'Extra Slim', store: 'Lorenzo / Drop 6' },
    { label: 'Slim',       store: 'Lorenzo / Drop 4' },
    { label: 'Classic',    store: 'Alexander / Drop 4' },
    { label: 'Wide',       store: 'Alexander / Drop 2' }
  ];
  function fitDisplayLabel(store) { for (var i = 0; i < FIT_MAP.length; i++) { if (FIT_MAP[i].store === store) return FIT_MAP[i].label; } return fitLabel(store); }
  var LAPEL_SUB = { Notch: 'Classic single step', Peak: 'Sharp upswept' };
  var MODE_LABELS = { set: 'Full Suit', jacket: 'Jacket Only', pants: 'Trousers Only' };

  // Fit-guide drawer content. Each fit shows THREE shots (front / side / detail).
  // Image URLs come from the fit-guide block's data-fitguide (theme-asset URLs); the 12
  // assets ship with this bundle. Copy below is the APPROVED FINAL fit-guide copy
  // (signed off on staging) -- do not edit without Tal's sign-off.
  var FIT_GUIDE = [
    { fit: 'Extra Slim', slug: 'extra-slim', desc: 'Our most tapered cut. For a lean, athletic build \u2014 chest fuller than the waist, with standard-to-broad shoulders.' },
    { fit: 'Slim',       slug: 'slim',       desc: 'A slim, lightly tapered cut for a lean, balanced build, where the chest and midsection sit about even.' },
    { fit: 'Classic',    slug: 'classic',    desc: 'A comfortable regular cut for a build where the midsection sits a little fuller than the chest.' },
    { fit: 'Wide',       slug: 'wide',       desc: 'Our most generous cut, with extra room through the chest and waist \u2014 for a fuller, broader build.' }
  ];
  var FG_SHOTS = ['front', 'side', 'detail'];

  // ---------- boot: group every mount by SKU into one controller ----------
  function boot() {
    var nodes = [].slice.call(document.querySelectorAll('[data-suit-builder]'));
    if (!nodes.length) return;
    var groups = {};
    nodes.forEach(function (n) { var sku = n.getAttribute('data-sku'); if (!sku) return; (groups[sku] = groups[sku] || []).push(n); });
    Object.keys(groups).forEach(function (sku) { makeController(sku, groups[sku]); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  function loadData(src, cb, err) {
    var s = document.getElementById('suit-data');
    if (s) { try { return cb(JSON.parse(s.textContent)); } catch (e) {} }
    if (src) return fetch(src).then(function (r) { return r.json(); }).then(cb).catch(err || function () {});
    (err || function () {})();
  }

  function makeController(sku, nodes) {
    if (window.__SUIT_CTRL__[sku]) return;
    var parts = {};
    nodes.forEach(function (n) { parts[attr(n, 'data-suit-part', 'all')] = n; });
    var jNode = parts.all || parts.jacket || nodes[0];       // owns lapel/fit settings + render images
    var mNode = parts.all || parts.mode   || nodes[0];       // owns which purchase modes are enabled
    var cNode = parts.all || parts.cart   || nodes[0];       // owns demo mode
    var cfg = {
      src:    attr(nodes[0], 'data-src', ''),
      cart:   attr(nodes[0], 'data-cart-add', '/cart/add.js'),
      images: (function () { try { return JSON.parse(attr(jNode, 'data-images', '{}')); } catch (e) { return {}; } })(),
      gswap:  attr(jNode, 'data-gallery-swap', '') === '1',
      deflap: attr(jNode, 'data-default-lapel', ''),
      deffit: attr(jNode, 'data-default-fit', ''),
      demo:   attr(cNode, 'data-demo', '') === '1',
      modesOn: attr(mNode, 'data-modes', 'set,jacket,pants').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
      fgImages: (function () { try { return JSON.parse(attr(parts.all || parts.fitguide || nodes[0], 'data-fitguide', '{}')); } catch (e) { return {}; } })()
    };
    nodes.forEach(function (n) { n.classList.add('sb'); });
    loadData(cfg.src, function (all) {
      var data = all && all[sku];
      if (!data || !data.jacket) { nodes.forEach(function (n) { if (n.getAttribute('data-suit-part') !== 'fitguide') n.innerHTML = '<p class="sb-err">SKU ' + sku + ' not found.</p>'; }); return; }
      var ctrl = new Ctrl(sku, parts, cfg, data);
      window.__SUIT_CTRL__[sku] = ctrl;
      ctrl.render();
    }, function () { nodes.forEach(function (n) { if (n.getAttribute('data-suit-part') !== 'fitguide') n.innerHTML = '<p class="sb-err">Could not load suit data.</p>'; }); });
  }

  // ---------- controller (single source of truth per product) ----------
  function Ctrl(sku, parts, cfg, data) {
    var self = this;
    var jacket = data.jacket, pants = data.pants || {};
    var lapels = Object.keys(jacket);
    var hasPants = Object.keys(pants).length > 0;
    var IMAGES = cfg.images, GSWAP = cfg.gswap, DEMO = cfg.demo, CART = cfg.cart, SKU = sku;
    var monolithic = !!parts.all;
    var resultEl = el('div', 'sb-result');

    function partExists(role) { return monolithic || !!parts[role]; }
    var AV = cfg.modesOn.filter(function (m) {
      if (m === 'set')    return partExists('jacket') && partExists('trousers') && hasPants;
      if (m === 'jacket') return partExists('jacket');
      if (m === 'pants')  return partExists('trousers') && hasPants;
      return false;
    });
    if (!AV.length) { AV = partExists('jacket') ? ['jacket'] : (hasPants ? ['pants'] : []); }

    var state = {
      mode: (AV.indexOf('set') > -1 ? 'set' : (AV[0] || 'jacket')),
      lapel: (cfg.deflap && jacket[cfg.deflap]) ? cfg.deflap : lapels[0],
      fit: null, size: null, length: null, waist: null, pantsFit: null, pantsFitTouched: false
    };
    if (cfg.deffit) { for (var f = 0; f < FIT_MAP.length; f++) { if (FIT_MAP[f].label === cfg.deffit) { var sf = FIT_MAP[f].store; if (jacket[state.lapel] && jacket[state.lapel][sf]) { state.fit = sf; if (pants[modelOf(sf)]) state.pantsFit = modelOf(sf); } break; } } }

    function rerender() { self.render(); }

    // ---- host-gallery swap ----
    var _lastGImg = null;
    function swapHostGallery(url) {
      if (!GSWAP || !url) return;
      var base = String(url).split(/[?&]width=/)[0];
      if (base === _lastGImg) return;
      var media = document.querySelectorAll('.product-gallery__media, [class*="gallery__media"]');
      if (!media.length) return;
      var first = media[0], srcs = first.querySelectorAll('source');
      for (var i = 0; i < srcs.length; i++) { srcs[i].parentNode.removeChild(srcs[i]); }
      var im = first.querySelector('img'); if (!im) return;
      var sep = base.indexOf('?') > -1 ? '&' : '?';
      function w(n) { return base + sep + 'width=' + n; }
      im.setAttribute('srcset', w(400) + ' 400w, ' + w(600) + ' 600w, ' + w(800) + ' 800w, ' + w(1200) + ' 1200w, ' + w(1600) + ' 1600w');
      im.setAttribute('sizes', '(max-width: 760px) 100vw, 50vw');
      im.setAttribute('src', w(1000)); im.src = w(1000);
      _lastGImg = base;
    }

    // ---- data helpers ----
    function unionKeys(objs) { var seen = {}, out = []; objs.forEach(function (o) { Object.keys(o || {}).forEach(function (k) { if (!seen[k]) { seen[k] = 1; out.push(k); } }); }); return out; }
    function jacketLeaf() { var j = jacket[state.lapel]; if (!j) return null; j = j[state.fit]; if (!j) return null; j = j[state.size]; if (!j) return null; return j[state.length] || null; }
    function pantsFitKey() { return state.pantsFit; }
    function pantsLeaf() { var pf = pantsFitKey(); return (pf && state.waist && pants[pf]) ? (pants[pf][state.waist] || null) : null; }
    function jacketSizes() { var lap = jacket[state.lapel] || {}; var out = unionKeys(Object.keys(lap).map(function (fk) { return lap[fk]; })); out.sort(function (a, b) { return (+a) - (+b); }); return out; }
    function orderLengths(keys) { var order = ['Short', 'Regular', 'Long'], out = []; order.forEach(function (o) { if (keys.indexOf(o) > -1) out.push(o); }); keys.forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); }); return out; }
    function jacketLengths() { var lap = jacket[state.lapel] || {}, leaves = []; Object.keys(lap).forEach(function (fk) { Object.keys(lap[fk]).forEach(function (s) { leaves.push(lap[fk][s]); }); }); return orderLengths(unionKeys(leaves)); }
    function pantsWaists() { var seen = {}, out = []; Object.keys(pants).forEach(function (fk) { Object.keys(pants[fk]).forEach(function (w) { if (!seen[w]) { seen[w] = 1; out.push(w); } }); }); out.sort(function (a, b) { return (+a) - (+b); }); return out; }

    function normalize() {
      if (state.fit && !jacket[state.lapel][state.fit]) { state.fit = null; state.size = null; state.length = null; }
      if (state.size != null && jacketSizes().indexOf(String(state.size)) < 0) state.size = null;
      if (state.fit && state.size != null && jacket[state.lapel][state.fit] && !jacket[state.lapel][state.fit][state.size]) state.size = null;
      if (state.length != null && jacketLengths().indexOf(state.length) < 0) state.length = null;
      if (state.fit && state.size != null) { var node = jacket[state.lapel][state.fit][state.size]; if (state.length != null && (!node || !node[state.length])) state.length = null; }
      if (state.pantsFit && !pants[state.pantsFit]) state.pantsFit = null;
      var pf = pantsFitKey();
      if (pf && pants[pf] && state.waist != null && Object.keys(pants[pf]).indexOf(String(state.waist)) < 0) state.waist = null;
    }

    // ---- row builders ----
    function optRow(label, values, current, onPick, availMap, labelFn) {
      var row = el('div', 'sb-row');
      row.appendChild(el('span', 'sb-label', label));
      var opts = el('div', 'sb-opts');
      values.forEach(function (v) {
        var b = el('button', 'sb-opt', labelFn ? labelFn(v) : String(v)); b.type = 'button';
        if (String(v) === String(current)) b.classList.add('is-sel');
        if (availMap && availMap[v] === false) { b.classList.add('is-oos'); b.disabled = true; b.title = 'Out of stock'; }
        b.addEventListener('click', function () { if (!b.disabled) onPick(v); });
        opts.appendChild(b);
      });
      row.appendChild(opts); return row;
    }
    function lapelRow() {
      var row = el('div', 'sb-row');
      row.appendChild(el('span', 'sb-label', 'Lapel'));
      var opts = el('div', 'sb-opts');
      lapels.forEach(function (v) {
        var b = el('button', 'sb-opt sb-opt--stack'); b.type = 'button';
        if (String(v) === String(state.lapel)) b.classList.add('is-sel');
        b.appendChild(el('span', 'sb-opt__name', v));
        if (LAPEL_SUB[v]) b.appendChild(el('span', 'sb-opt__sub', LAPEL_SUB[v]));
        b.addEventListener('click', function () { state.lapel = v; rerender(); });
        opts.appendChild(b);
      });
      row.appendChild(opts); return row;
    }

    function appendJacketRows(box) {
      // Fit-guide trigger sits at the TOP of the jacket block, left-aligned above the Lapel label.
      if (partExists('fitguide')) {
        var lk = el('button', 'sb-fitguide-link', 'How to choose a fit'); lk.type = 'button';
        lk.addEventListener('click', function () { self.openFitGuide(); });
        box.appendChild(lk);
      }
      if (lapels.length > 1) box.appendChild(lapelRow());
      // FIT -- one row of four named fits (sec 12: only those whose store value exists for this lapel).
      var fitOpts = [];
      FIT_MAP.forEach(function (fm) { if (jacket[state.lapel] && jacket[state.lapel][fm.store]) fitOpts.push(fm.store); });
      box.appendChild(optRow('Fit', fitOpts, state.fit, function (v) {
        state.fit = v; state.size = null; state.length = null;
        if (!state.pantsFitTouched && pants[modelOf(v)]) state.pantsFit = modelOf(v);
        rerender();
      }, null, fitDisplayLabel));
      if (state.fit) box.appendChild(el('div', 'sb-fit-attr', dropOf(state.fit) + ' ' + modelOf(state.fit)));
      // SIZE
      var sizeList, sizeAvail = null;
      if (state.fit && jacket[state.lapel][state.fit]) {
        var fnode = jacket[state.lapel][state.fit];
        sizeList = Object.keys(fnode).sort(function (a, b) { return (+a) - (+b); });
        sizeAvail = {}; sizeList.forEach(function (s) { sizeAvail[s] = Object.keys(fnode[s]).some(function (L) { return fnode[s][L].avail !== false; }); });
      } else { sizeList = jacketSizes(); }
      box.appendChild(optRow('Size', sizeList, state.size, function (v) { state.size = v; rerender(); }, sizeAvail));
      // LENGTH
      var lenList, lenAvail = null;
      if (state.fit && state.size != null && jacket[state.lapel][state.fit][state.size]) {
        var lnode = jacket[state.lapel][state.fit][state.size];
        lenList = orderLengths(Object.keys(lnode));
        lenAvail = {}; lenList.forEach(function (L) { lenAvail[L] = lnode[L].avail !== false; });
      } else { lenList = jacketLengths(); }
      box.appendChild(optRow('Length', lenList, state.length, function (v) { state.length = v; rerender(); }, lenAvail));
    }

    function appendTrouserRows(box) {
      box.appendChild(optRow('Trouser fit', Object.keys(pants), state.pantsFit, function (v) { state.pantsFit = v; state.pantsFitTouched = true; rerender(); }, null, fitLabel));
      var pf = pantsFitKey(), waistList, waistAvail = null;
      if (pf && pants[pf]) {
        waistList = Object.keys(pants[pf]).sort(function (a, b) { return (+a) - (+b); });
        waistAvail = {}; waistList.forEach(function (w) { waistAvail[w] = pants[pf][w].avail !== false; });
      } else { waistList = pantsWaists(); }
      box.appendChild(optRow('Trouser waist', waistList, state.waist, function (v) { state.waist = v; rerender(); }, waistAvail));
    }

    // ---- readiness / price / cart ----
    function compute() {
      var jl = jacketLeaf(), pl = pantsLeaf(), ready = false, total = 0, sub = '';
      if (state.mode === 'set')    { ready = !!(jl && jl.avail !== false && pl); total = ready ? (+jl.price + +pl.price) : 0; sub = ready ? ('Jacket ' + money(jl.price) + ' + Trousers ' + money(pl.price)) : ''; }
      if (state.mode === 'jacket') { ready = !!(jl && jl.avail !== false);       total = ready ? +jl.price : 0; }
      if (state.mode === 'pants')  { ready = !!pl;                               total = ready ? +pl.price : 0; }
      return { jl: jl, pl: pl, ready: ready, total: total, sub: sub };
    }
    function modeTabs() {
      var modes = el('div', 'sb-modes');
      AV.forEach(function (m) {
        var b = el('button', 'sb-mode', MODE_LABELS[m]); b.type = 'button'; b.setAttribute('data-mode', m);
        if (m === state.mode) b.classList.add('is-sel');
        b.addEventListener('click', function () { state.mode = m; rerender(); });
        modes.appendChild(b);
      });
      return modes;
    }
    // Representative base prices (pricing is flat: all jackets one price, all trousers one price), used as the
    // starting price shown on load so the PDP always shows a number -- like a standard product page.
    var baseJacket = 0, baseTrouser = 0;
    (function () { for (var lp in jacket) { for (var ft in jacket[lp]) { for (var sz in jacket[lp][ft]) { for (var ln in jacket[lp][ft][sz]) { baseJacket = +jacket[lp][ft][sz][ln].price; return; } } } } })();
    (function () { for (var pf in pants) { for (var w in pants[pf]) { baseTrouser = +pants[pf][w].price; return; } } })();
    function baseForMode() { return state.mode === 'set' ? (baseJacket + baseTrouser) : (state.mode === 'jacket' ? baseJacket : baseTrouser); }

    function priceInto(box) {
      var c = compute();
      box.appendChild(el('span', 'sb-total', money(c.ready ? c.total : baseForMode())));   // always show a price number
      if (c.ready && c.sub) box.appendChild(el('span', 'sb-sub', c.sub));
      else box.appendChild(el('span', 'sb-sub', state.mode === 'set' ? 'Select your jacket and trousers' : (state.mode === 'jacket' ? 'Select your jacket' : 'Select your trousers')));
    }

    function addToCart(jl, pl, addBtn) {
      var items = [], setId = SKU + '-' + Math.floor(Date.now());
      if (state.mode === 'set') {
        items.push({ id: +num(jl.vid), quantity: 1, properties: { _suit_set: setId, _set_role: 'Jacket' } });
        items.push({ id: +num(pl.vid), quantity: 1, properties: { _suit_set: setId, _set_role: 'Trousers' } });
      } else if (state.mode === 'jacket') { items.push({ id: +num(jl.vid), quantity: 1 }); }
      else { items.push({ id: +num(pl.vid), quantity: 1 }); }
      if (DEMO) { resultEl.innerHTML = '<strong>Would add ' + items.length + ' line item' + (items.length > 1 ? 's' : '') + ':</strong><pre>' + JSON.stringify(items, null, 2) + '</pre>'; return; }
      addBtn.disabled = true; var label = addBtn.textContent; addBtn.textContent = 'Adding\u2026';
      fetch(CART, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) { addBtn.disabled = false; addBtn.textContent = label; if (res.ok) window.location.href = '/cart'; else alert('Sorry \u2014 could not add to cart. Please try again.'); })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = label; alert('Sorry \u2014 could not add to cart. Please try again.'); });
    }

    // ---- fit-guide drawer (right slide, cart-drawer pattern) ----
    var _fgPanel = null;
    function buildFitGuide() {
      if (_fgPanel) return;
      var wrap = el('div', 'sb-fitguide');
      var overlay = el('div', 'sb-fg-overlay'); overlay.addEventListener('click', function () { self.closeFitGuide(); });
      var panel = el('div', 'sb-fg-panel');
      var head = el('div', 'sb-fg-head');
      head.appendChild(el('span', 'sb-fg-title', 'How to Choose a Fit'));
      var close = el('button', 'sb-fg-close', '\u00d7'); close.type = 'button'; close.setAttribute('aria-label', 'Close'); close.addEventListener('click', function () { self.closeFitGuide(); });
      head.appendChild(close);
      panel.appendChild(head);
      var body = el('div', 'sb-fg-body');
      FIT_GUIDE.forEach(function (g) {
        var card = el('div', 'sb-fg-card');
        var gal = el('div', 'sb-fg-gallery');
        var imgs = cfg.fgImages[g.slug] || {};
        FG_SHOTS.forEach(function (kind) {
          var shot = el('div', 'sb-fg-shot');
          var ph = el('span', 'sb-fg-shotph', kind);
          var url = imgs[kind];
          if (url) {
            var im = el('img'); im.alt = g.fit + ' \u2014 ' + kind;
            im.onerror = function () { if (shot.contains(im)) shot.removeChild(im); if (!shot.contains(ph)) shot.appendChild(ph); };
            shot.appendChild(im); im.src = url;   // placeholder only added if the image fails to load (asset not uploaded yet)
          } else { shot.appendChild(ph); }
          gal.appendChild(shot);
        });
        card.appendChild(gal);
        card.appendChild(el('h4', 'sb-fg-fit', g.fit));
        card.appendChild(el('p', 'sb-fg-desc', g.desc));
        body.appendChild(card);
      });
      panel.appendChild(body);
      wrap.appendChild(overlay); wrap.appendChild(panel);
      document.body.appendChild(wrap);              // lift out of block flow so it overlays like the cart drawer
      _fgPanel = wrap;
    }
    this.openFitGuide  = function () { buildFitGuide(); _fgPanel.classList.add('is-open'); document.documentElement.classList.add('sb-fg-lock'); };
    this.closeFitGuide = function () { if (_fgPanel) _fgPanel.classList.remove('is-open'); document.documentElement.classList.remove('sb-fg-lock'); };

    // ---- per-block renderers ----
    function prep(node, cls) { node.className = 'sb sb-panel-only sb-part ' + cls; node.innerHTML = ''; return node; }
    function muted(node, msg) { node.appendChild(el('div', 'sb-part-muted', msg)); }

    function renderModeBlock(node)  { prep(node, 'sb-part--mode'); if (AV.length > 1) node.appendChild(modeTabs()); }
    function renderPriceBlock(node) { prep(node, 'sb-part--price'); priceInto(node); }
    function renderJacketBlock(node, show)  { prep(node, 'sb-part--jacket'); if (!show) { muted(node, 'Jacket \u2014 not included in this option.'); return; } appendJacketRows(node); }
    function renderTrouserBlock(node, show) { prep(node, 'sb-part--trousers'); if (!hasPants) { muted(node, 'Trousers unavailable for this suit.'); return; } if (!show) { muted(node, 'Trousers \u2014 not included in this option.'); return; } appendTrouserRows(node); }
    function renderCartBlock(node) {                                   // button ONLY, native Prestige markup (rendered by Liquid)
      node.className = 'sb sb-panel-only sb-part sb-part--cart';       // set layout class WITHOUT wiping the native button
      var btn = node.querySelector('.button');
      if (!btn) { return; }
      var c = compute();
      btn.disabled = !c.ready;
      btn.textContent = state.mode === 'set' ? 'Add Suit to Cart' : (state.mode === 'jacket' ? 'Add Jacket to Cart' : 'Add Trousers to Cart');
      btn.onclick = function () { if (!btn.disabled) addToCart(c.jl, c.pl, btn); };
      if (DEMO && resultEl.parentNode !== node) node.appendChild(resultEl);
    }
    function renderFitGuideBlock(node) { node.className = 'sb sb-fitguide-marker'; node.innerHTML = ''; }  // drawer builds lazily on first open

    function renderMono(node, showJacket, showPants) {                 // legacy all-in-one
      prep(node, 'sb-part--all');
      if (AV.length > 1) node.appendChild(modeTabs());
      var box = el('div', 'sb-selectors');
      if (showJacket) appendJacketRows(box);
      if (showPants && hasPants) appendTrouserRows(box);
      node.appendChild(box);
      var price = el('div', 'sb-price'); priceInto(price); node.appendChild(price);
      var addBtn = el('button', 'sb-add'); addBtn.type = 'button';
      var c = compute(); addBtn.disabled = !c.ready;
      addBtn.textContent = state.mode === 'set' ? 'Add Suit to Cart' : (state.mode === 'jacket' ? 'Add Jacket to Cart' : 'Add Trousers to Cart');
      addBtn.onclick = function () { if (!addBtn.disabled) addToCart(c.jl, c.pl, addBtn); };
      node.appendChild(addBtn);
      node.appendChild(el('div', 'sb-note', state.mode === 'set' ? 'Jacket and trousers ship as a set. Final sale.' : 'Final sale.'));
      if (DEMO) node.appendChild(resultEl);
    }

    this.render = function () {
      normalize();
      if (GSWAP) { var glap = state.lapel || lapels[0]; swapHostGallery(IMAGES[glap] || IMAGES[String(glap).toLowerCase()]); }
      var showJacket = state.mode === 'set' || state.mode === 'jacket';
      var showPants  = state.mode === 'set' || state.mode === 'pants';
      if (monolithic) { renderMono(parts.all, showJacket, showPants); return; }
      if (parts.mode)     renderModeBlock(parts.mode);
      if (parts.price)    renderPriceBlock(parts.price);
      if (parts.jacket)   renderJacketBlock(parts.jacket, showJacket);
      if (parts.trousers) renderTrouserBlock(parts.trousers, showPants);
      if (parts.cart)     renderCartBlock(parts.cart);
      if (parts.fitguide) renderFitGuideBlock(parts.fitguide);
    };
  }
})();
